<template>
    <register-layout v-on:submit="submit">
        <div class="tw-p-6">
            <div class="tw-text-xl tw-font-bold tw-col-span-2">{{$word.about_you}}:</div>

         <div class="tw-mt-3">
                <div class="tw-mb-1 tw-font-bold">{{$word.i_am}}:
                    <span class="tw-font-bold tw-text-red-500">*</span>
                </div>
                <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                    <span class="tw-block filter-button pointer" :class="{'--active' : states.form.i_am === 'man'}"
                          @click.prevent="states.form.i_am = 'man'">
                        <i class="bx bx-male"></i>
                        <span>{{$word.man}}</span>
                    </span>
                    <span class="tw-ml-1 filter-button pointer" :class="{'--active' : states.form.i_am === 'woman'}"
                          @click.prevent="states.form.i_am = 'woman'">
                        <i class="bx bx-female"></i>
                        <span>{{$word.woman}}</span>
                    </span>
                </div>
                <div v-html="_.get(errors,'i_am.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>
            <div class="tw-mt-3">
                <div class="tw-mb-1 tw-font-bold">{{$word.looking_for}}:
                    <span class="tw-font-bold tw-text-red-500">*</span>
                </div>
                <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                    <span class="tw-block filter-button pointer"
                          :class="{'--active' : states.form.looking_for === 'man'}"
                          v-on:click.prevent="states.form.looking_for = 'man'">
                        <i class="bx bx-male"></i>
                        <span>{{$word.man}}</span>
                    </span>
                    <span class="tw-ml-1 filter-button pointer"
                          :class="{'--active' : states.form.looking_for === 'woman'}"
                          v-on:click.prevent="states.form.looking_for = 'woman'">
                        <i class="bx bx-female"></i>
                        <span>{{$word.woman}}</span>
                    </span>
                </div>
                <div v-html="_.get(errors,'looking_for.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>
            <div class="tw-mt-3">
                <div class="tw-mb-1 tw-font-bold">{{$word.between_ages}}:</div>
                <div class="tw-flex tw-items-center tw-space-x-2">
                    <select class="tw-flex-1 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-p-2"
                            v-model="states.form.start_age">
                        <option :value="age" v-for="age in states.ages">{{age}}</option>
                    </select>
                    <div class="tw-font-bold">—</div>
                    <select class="tw-flex-1 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-p-2"
                            v-model="states.form.end_age">
                        <option :value="age" v-for="age in states.ages">{{age}}</option>
                    </select>
                </div>
                <div v-html="_.get(errors,'start_age.0')" class="tw-text-red-500 tw-mt-1"></div>
                <div v-html="_.get(errors,'end_age.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>



            <div class="tw-mt-3">
                <div class="tw-mb-1 tw-font-bold">{{$word.favorite_countries}}:
                    <span class="tw-font-bold tw-text-red-500">*</span>
                </div>
                <div>
                    <v-select-favorite-countries direction="top" v-model="states.form.countries"/>
                </div>
                <div v-html="_.get(errors,'countries.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>

        </div>
    </register-layout>
</template>
<script>
    import store from './register-store'
    import RegisterLayout from './register-layout'

    export default {
        components: {RegisterLayout},
        data: v => ({
            states: store.states,
            errors: {},
        }),
        created() {
            this.store = store
        },
        methods: {
            submit() {
                store.states.loading = true
                axios.post('/validate-register', store.composeForm())
                    .then(() => {
                        this.errors = {}
                    })
                    .catch(err => {
                        err.response.status === 422 && (this.errors = err.response.data.errors)
                    })
                    .finally(() => {
                        store.states.loading = false
                        if(store.hasNoErrors(this.errors,['countries'])){
                            store.states.current_step++;
                        }
                    })
            },
        },
    }
</script>
